import { createSelector } from '@ngrx/store';
import { ROVER_MOS_DEVICE_ID } from '@src/suite/common/enums/constants';
import { selectMosDevices } from '@src/suite/common/store/global-tables/global-tables.selectors';

export const selectMosItems = createSelector(selectMosDevices, mosDevices => (mosDevices ?? []).filter(mos => mos.ID !== ROVER_MOS_DEVICE_ID).map(mos => ({ id: mos.ID, title: mos.Description })));
export const selectMosStorySendDevices = createSelector(selectMosDevices, mosDevices => {
    return (mosDevices ?? []).filter(mos => mos.ID !== ROVER_MOS_DEVICE_ID && mos.StorySend);
});
